<script>
  import { onDestroy } from 'svelte'
  import { flash_content, hero_expanded } from '../stores.js'
  import { fade } from 'svelte/transition'

  // flash content obj can have
  // message (bool)
  // icon (string)
  // bright (bool)
  // centered (bool)

  let duration = 3000
  
  let message
  let icon
  let is_bright = false
  let is_centered = false

  let visible
  let timeout
  let hovering

  const onMessageChange = (flash_content) => {
    if (typeof flash_content === 'object') {
      message  = flash_content.message
      icon = flash_content.icon
      is_bright = flash_content.bright
      is_centered = flash_content.centered
    } 
    else if (typeof flash_content === 'string') {
      hide()
      message  = flash_content
    }
    else {
      console.warn('expecting flash content as an object or a string')
      return
    }

    clearTimeout(timeout)
    
    if (!message) {
      hide()
    } else {
      visible = true
      timeout = setTimeout(() => hide(), duration)
    }
  }
 
  $: onMessageChange($flash_content)
  
  onDestroy(()=> clearTimeout(timeout))

  function hide() {
    visible = false
    icon = undefined
    is_bright = false
  }

</script>

{#if visible || hovering}
  <div 
    class="flash"
    class:on_cover={$hero_expanded}
    class:is_bright
    class:is_centered
    on:mouseover={() => hovering = true}
    on:mouseout={() => hovering = false}
    transition:fade="{{duration: 300}}">
    {#if icon}
      <svg class="icon"><use xlink:href="#icon-{icon}"/></svg>
    {/if}
    { message }
  </div>
{/if}

<style>
  div {
    position: fixed;
    z-index: 2;
    display: flex;
    align-items: center;
    left: 6rem;
    bottom: 2rem;
    padding: 1.5rem 2rem;
    font-size: 1.6rem;
    letter-spacing: 0.25px;
    line-height: 1.2em;
    color: var(--c-text-on-fill-hover);
    background-color: var(--c-flash-bg);
    z-index: 10;
    border-radius: var(--border-radius);
  }
  div.on_cover {
    left: 10rem;
    bottom: 6rem;
  }
  div.is_bright {
    background-color: var(--c-flash-onboarding-bg);
  }
  div.is_centered {
    left: 50%;
    transform: translateX(-50%);
    bottom: 20%;
  }
  .icon {
    display: inline-block;
    margin-right: 1rem;
    fill: var(--c-text-on-fill);
    stroke: var(--c-text-on-fill);
    width: 4rem;
    height: 4rem;
  }
  @media only screen and (max-width: 1024px) {
    div,
    div.on_cover {
      left: 2rem;
    }
  }
</style>